<template>
    <div v-if="canShow('脏腑辨证') && info && info.tizhi_zangfu">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">脏腑辨证</div>
        </div>
        <div class="assessment">
            <div class="sick-dosc">
                <div class="sick-inner" v-for="(item, index) in info.tizhi_zangfu" :key="index">
                    <div class="flex inner-name">
                        <div class="flex-1">{{ item.ZangfuTezheng }}</div>
                        <div>{{ ZangFutext(item.Level) }}</div>
                    </div>
                    <div class="sick-title">注意事项</div>
                    <div>{{ item.Precautions }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin, ZangFutext } from '../helpers';

export default {
    name: 'ReportZangfu',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info'])
    },
    methods: {
        ZangFutext
    }
};
</script>
<style lang="scss" scoped>
@import './Zangfu.scss';
</style>
